var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"context-menu-option",style:({ color: _vm.color }),on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }